import React from "react"
import PropTypes from "prop-types"
import {
  CardHeader,
  CardContent,
  Button,
  CardFooter,
  CardTitle,
  CardDescription,
} from "ksc-portal-common-components/shadcn"
import { ASK_ADMIN_TITLE } from "../constants"

const AdminReset = ({ backToLogin }) => (
  <>
    <CardHeader className="flex flex-col items-center gap-4">
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Illustrations">
          <circle
            id="Ellipse 85"
            cx="33"
            cy="33"
            r="32"
            fill="#D1D5DB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            id="Ellipse 84"
            cx="33"
            cy="33"
            r="24.96"
            fill="#F7FAFB"
            stroke="#9BA3AF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.279 26.4788C22.9175 28.2966 22.1111 30.5541 22.1111 33C22.1111 39.0138 26.9862 43.8889 33 43.8889C35.4459 43.8889 37.7034 43.0825 39.5212 41.721L24.279 26.4788ZM22.8084 23.4014C20.4471 25.9076 19 29.2848 19 33C19 40.732 25.268 47 33 47C36.7152 47 40.0924 45.5529 42.5986 43.1916C42.7193 43.1236 42.8328 43.0382 42.9355 42.9355C43.0382 42.8328 43.1236 42.7193 43.1916 42.5986C45.5529 40.0924 47 36.7152 47 33C47 25.268 40.732 19 33 19C29.2848 19 25.9076 20.4471 23.4014 22.8084C23.2807 22.8764 23.1672 22.9618 23.0645 23.0645C22.9618 23.1672 22.8764 23.2807 22.8084 23.4014ZM26.4788 24.279L41.721 39.5212C43.0825 37.7034 43.8889 35.4459 43.8889 33C43.8889 26.9862 39.0138 22.1111 33 22.1111C30.5541 22.1111 28.2966 22.9175 26.4788 24.279Z"
            fill="#B30009"
          />
        </g>
      </svg>
    </CardHeader>
    <CardContent className="space-y-2">
      <CardTitle className="text-center text-2xl font-medium text-foreground">
        {ASK_ADMIN_TITLE}
      </CardTitle>
      <CardDescription className="text-center text-sm text-muted-foreground">
        Please contact a member of your admin team.
      </CardDescription>
    </CardContent>
    <CardFooter className="flex justify-center">
      <Button variant="default" onClick={backToLogin} className="w-full">
        Back to Login
      </Button>
    </CardFooter>
  </>
)

AdminReset.propTypes = {
  backToLogin: PropTypes.func.isRequired,
}

export default AdminReset
